"use strict"
const angular = require("angular")
import { getOrderedMarkerData } from "../shared/utils"
/*@ngInject*/
export function dataServiceService($http, $q) {
  // AngularJS will instantiate a singleton by calling "new" on this function

  let storedData
  //let previewMods;

  let service = {
    getData: (mapid) => {
      let promise = $q((resolve, reject) => {
        // if (/* some async task is all good */) {
        if (storedData) {
          resolve(storedData)
        } else {
          //***** temp for preview purpose - to be removed ******* //
          // if(mapid === '5a122e5dac4c7c80c90f900b') {
          //   mapid = '54f4c01880110ec870407bad';
          //   previewMods = {
          //     showavailability: true
          //   };
          // }

          $http.get(`/api/campsites/${mapid}`, { cache: true }).then((campsiteresponse) => {
            //** temp adding an preview mods if any
            //campsiteresponse.data = Object.assign(campsiteresponse.data, previewMods);

            // return resp.data;
            const campsiteVersion = campsiteresponse.data.version || ""
            $http
              .get(`/api/markers/${campsiteresponse.data.name}${campsiteVersion}`, { cache: true })
              .then((markerresponse) => {
                for (let i = 0; i < markerresponse.data.length; i++) {
                  const marker = markerresponse.data[i]
                  if (marker.physicalunitid && !marker.physicalunitids.length) {
                    marker.physicalunitids.push(marker.physicalunitid)
                  }
                  marker.type = "pitch"
                  if (marker.name) {
                    if (campsiteresponse.data.pitchnumberbyarea && marker.area) {
                      marker.urlstringid = `${marker.name.toLowerCase()}-${marker.area
                        .replace(/[^A-Z0-9]+/gi, "_")
                        .toLowerCase()}`
                      marker.nameandareastring = `${marker.name.toLowerCase()} - ${marker.area.toLowerCase()}`
                    } else {
                      marker.urlstringid = marker.name.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
                    }
                  }
                }

                for (let c = 0; c < campsiteresponse.data.areaoptions.length; c++) {
                  const areaMarkerData = campsiteresponse.data.areaoptions[c]
                  areaMarkerData.urlstringid = areaMarkerData.name.replace(/[^A-Z0-9]+/gi, "_").toLowerCase()
                }

                let orderedMarkerData = []
                if (!campsiteresponse.data.pitchnumberbyarea) {
                  orderedMarkerData = getOrderedMarkerData(markerresponse.data)
                } else {
                  orderedMarkerData = []
                  let areaNames = []
                  let markersByArea = {}

                  for (let i = 0; i < markerresponse.data.length; i++) {
                    const marker = markerresponse.data[i]
                    if (areaNames.indexOf(marker.area) === -1) {
                      areaNames.push(marker.area)
                      markersByArea[marker.area] = [marker]
                    } else {
                      markersByArea[marker.area].push(marker)
                    }
                  }

                  angular.forEach(markersByArea, (areaCollection) => {
                    const orderedAreaCollection = getOrderedMarkerData(areaCollection)
                    for (let j = 0; j < orderedAreaCollection.length; j++) {
                      orderedMarkerData.push(orderedAreaCollection[j])
                    }
                  })
                }

                campsiteresponse.data.markers = orderedMarkerData
                if (campsiteresponse.data) {
                  storedData = campsiteresponse.data
                  resolve(campsiteresponse.data)
                } else {
                  reject("Oops... something went wrong")
                }
              })
          })
        }
      })

      return promise
    },
  }

  return service
}

export default angular.module("makeamapAngularApp.dataService", []).service("dataService", dataServiceService).name
